import styled from 'foundations-theming/utils';
import { useIsPillBorderRadius } from 'portals-platform-lib';

// styled.div is required here because View has no prop for box-shadow (non-token
// value) and no prop for border with a non-token color.
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDiv = styled.div.withConfig({
  displayName: "StyledTable__StyledDiv"
})(["", " overflow:hidden;table{table-layout:fixed;}"], ({
  theme,
  $isUsingPillBorderRadius
}) => `
    box-shadow: ${theme.boxShadow['100']};
    border-radius: ${$isUsingPillBorderRadius ? theme.borderRadius['0'] : theme.borderRadius['300']};
    border: 1px solid ${theme.color['border-transitional-core-subtle']};
  `);
export const StyledTable = props => {
  const isPill = useIsPillBorderRadius();
  return /*#__PURE__*/_jsx(StyledDiv, Object.assign({}, props, {
    $isUsingPillBorderRadius: isPill
  }));
};